import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import isPromise from 'is-promise';

import { CardElement, injectStripe, Elements, StripeProvider } from 'react-stripe-elements';
import { Button, FormGroup, Col, Row } from 'reactstrap';

import { InputField, InputErrors, Form } from '../form';


import config from '../../config';

import { Coupon } from '../../api';
import DefaultPaymentSource from './DefaultPaymentSource';


const mapStateToProps = state => ({ currentAccount: state.currentProject.account });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({  }, dispatch)
};


const simpleMemoize = fn => {
  let lastArg
  let lastResult
  return arg => {
    if (arg !== lastArg) {
      lastArg = arg
      lastResult = fn(arg)
    }
    return lastResult
  }
}

const couponAvailableValidate = simpleMemoize( async value => {
  
  if (value && value !== ''){
    try {
      await Coupon.check(value)
    }
    catch(err) {
      // console.log(err, err.response)
      return err.response && err.response.data && err.response.data.errors && err.response.data.errors.coupon[0]
    }
  }
  
})



class _CardForm extends Component{
  
  constructor (props){
    super(props);
    
    this.handleError = this.handleError.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    
    this.toggleCoupon = this.toggleCoupon.bind(this)
    this.toggleCardChange = this.toggleCardChange.bind(this)
    
    
    this.state = {
      error: null,
      couponInput: false,
      changeDefaultSource: false
    }
  }
  
  
  checkCoupon (){
    
  }
  
  toggleCardChange (){
    this.setState({changeDefaultSource: !this.state.changeDefaultSource});
  }
  
  toggleCoupon (ev){
    if (ev && ev.preventDefault)
      ev.preventDefault();
    
    this.setState({couponInput: !this.state.couponInput})
  }
  
  handleError (res){
    if (res && (res.message || res.error))
      this.setState({
        error: res.message || res.error,
        submitting: false
      })

    const { changeLoading } = this.props;
    if (changeLoading)
      changeLoading(false);
  }
  
  handleSuccess (res) {
    // this.props.onSuccess()

    const { changeLoading } = this.props;
    
    if (res && res.error){
      this.handleError(res.error)
    }
    else if (res && this.props.onSuccess){
      const successRes = this.props.onSuccess(res)
      if (isPromise(successRes)) {
        successRes.then(this.handleError, this.handleError)
      }
    }
    else{
      this.handleError({message: "Something went wrong on the Stripe side. Please try again."})
    }
    this.setState({submitting: false});
    
    if (changeLoading)
      changeLoading(false);
  }
  
  handleSubmit (ev) {
    ev.preventDefault();
    const { defaultSource, changeLoading } = this.props;
    const { changeDefaultSource } = this.state;
    const useDefaultSource = defaultSource && !changeDefaultSource;
    
    this.setState({error: null, submitting: true});
    if (changeLoading)
      changeLoading(true);
    
    if (useDefaultSource){
      this.handleSuccess({});
    }
    else if (this.props.stripe) {
      this.props.stripe
        .createToken()
        .then(this.handleSuccess, this.handleError);
    } else {
      console.log("Stripe.js hasn't loaded yet."); 
    }
  }
  
  
  
  
  render() {
    const { currentAccount: {coupon}, submitText, outsideLoading, defaultSource } = this.props
    const { submitting, error, couponInput, changeDefaultSource } = this.state
    
    const useDefaultSource = defaultSource && !changeDefaultSource;
    
    // https://stripe.com/about/resources
    return (
      <form className="payment-method-form" onSubmit={this.handleSubmit}>
        <FormGroup>
          <Row>
            <Col sm={6}>
              <label htmlFor="card-details">Card details:</label>
            </Col>
            <Col sm={6} className="small text-right">
            </Col>
          </Row>
          
          {useDefaultSource
            ?
            <DefaultPaymentSource defaultSource={defaultSource} onChangeCard={this.toggleCardChange} />
            : 
            <CardElement id="card-details" onReady={(el) => el.focus()} style={{base: {fontSize: '15.6px', fontFamily: "Montserrat, 'Helvetica Neue', Arial, sans-serif"}}} />
          }
          <InputErrors submitError={error} submitting={submitting} />
        </FormGroup>
        
        
        <FormGroup>
          <Row>
            <Col sm={6} className="small">
              
              {coupon && coupon.valid && <span>
                Coupon will apply: <nobr>{coupon.id} ({coupon.percent_off ? coupon.percent_off+"%" : "$" + (coupon.amount_off/100) } off)</nobr>
              </span>}
              {false && <Form
                validateOnBlur={true}
                onSubmit={() => null}
                
                render={() => (<React.Fragment>
                  {couponInput && <InputField name="coupon_code" validate={couponAvailableValidate} placeholder="Coupon code" />}
                  {!couponInput && <Button color="link" className="gray" onClick={this.toggleCoupon}>I have a coupon</Button>}
                </React.Fragment>)}
              />}
            </Col>
            <Col sm={6} className="small text-right">
              <Button color="primary" disabled={submitting || outsideLoading}>{ submitText || 'SUBSCRIBE'}</Button>
            </Col>
          </Row>
        </FormGroup>
        
        <div className="text-center">
          <img alt="" src="/img/powered-by-stripe.svg" />
        </div>
        
      </form>
    );
  }
}
const InjectedCardForm = injectStripe(connect(mapStateToProps, matchDispatchToProps)(_CardForm));


// const CurrentCard = () => null
  

class PaymentMethodForm extends Component {
  
  constructor() {
    super();
    this.state = { stripe: null };
  }
  
  componentDidMount() {
     this.setState({
       stripe: window.Stripe(config.stripePK),
     });
   }
  
  render() {
    const { onSuccess, submitText, loading, defaultSource, changeLoading } = this.props
    return (<StripeProvider stripe={this.state.stripe}>
      <Elements fonts={[{cssSrc: "https://fonts.googleapis.com/css?family=Montserrat:500&subset=cyrillic,cyrillic-ext,latin-ext"}]}>
        <InjectedCardForm {...{ onSuccess, submitText, outsideLoading: loading, defaultSource, changeLoading }} />
      </Elements>
    </StripeProvider>);
  }
}


export default PaymentMethodForm;


// WEBPACK FOOTER //
// ./src/components/billing/PaymentMethodForm.js